import { Text, View, Input, Image, Textarea, Prompt } from 'components';
import Base, { Config } from 'components/scourge/Base';
import React from 'react';
import Uploader from 'components/Uploader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './index.module.scss';
import cx from 'classnames'


interface State {
  userinfo: any
  params: {
    video?: string
    image?: string  //封面
    desc?: string
    tag?: string[]
    brand?: string
    scope_price?: number[]
    // supply?: {
    //   engine_brand?: string
    //   valve_brand?: string
    //   pump_brand?: string
    // }
  }
  tagSelected?: {
    value: string;
    list: string[]
  }[]
  wjBrand?: any[]
  ccBrand?: any[]

  currentEditTag?: string   //当前被选中的标签，（需要填写品牌的）
  supply?: {
    engine_brand?: string
    valve_brand?: string
    pump_brand?: string
  }


  showBrandSelector?: boolean
}

const TAGS_WITH_BRAND = [  //这几个标签需要填写品牌
  {name: '发动机', key: 'engine_brand', placeholder: '例如：五十铃'},
  {name: '分配阀', key: 'valve_brand', placeholder: '例如：东芝'},
  {name: '液压泵', key: 'pump_brand', placeholder: '例如：川崎泵、小挖泵'},
]

const TOASTPARAMS = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 1500,
  closeButton: false,
}

export default class Vip extends Base<any, State>  {
  public config: Config = {
    navigationBarTitleText: '上传视频'
  };

  public state: State = {
    userinfo: {},
    params: {
      // brand: "小松",
      // desc: "视频介绍啦啦啦",
      // scope_price: [1, 2],
      // tag: ["#冒黑白蓝烟:冒蓝烟"],
      // video: "https://assets.gongji58.com/2021-08-02/2-j2lvbl8vv61627886466.mp4"
    }
    // video: "https://assets.gongji58.com/2020-11-25/kk1dco193l1606273192.mp4",
    // imgs: ["https://assets.gongji58.com/2020-11-25/6hzwxhb8dh1606271966.png", "https://assets.gongji58.com/2020-11-25/cr5l4mtgwc1606271967.png", "https://assets.gongji58.com/2020-11-25/4uif0cxurm1606271967.png", "https://assets.gongji58.com/2020-11-25/t2qyr6ruj01606271967.png", "https://assets.gongji58.com/2020-11-25/96bzrfpydw1606271967.png", "https://assets.gongji58.com/2020-11-25/z5bju8o8gs1606271967.png"],
  };
  
  public componentDidShow() {
    // this.getUserInfo()
  }

  public async didMount() {
    this.getUserInfo()
    // this.getBrand()
  }

  public render() {
    const { userinfo, params, showBrandSelector } = this.state;

    return (
      <View className={styles.ignorecssContainer}>
        <ToastContainer className={styles.ToastContainer}/>


        <View className={styles.page}>
        <View className={styles.formBox}>

          {userinfo.uploader == 1 && 
            <View className={styles.sec}>
              <View className={styles.secInner} onClick={() => {
                // this.feedback.showFeedback('vlogPubFaultTypeModal')
              }}>
                <View className={this.cx(styles.title, styles.required)}>添加标签</View>
                <View className={styles.rig}>
                  
                  {this.parsedTag.length > 0? (
                    <Text className={styles.pdTxt}>{'修改 >'}</Text>
                  ): (
                    <Text className={styles.pdTxt}>{'点此选择 >'}</Text>
                  )}
                </View>
              </View>
              <View className={styles.smText}>（很重要，有助于你的视频上热点，而且方便用户搜索）</View>
              {this.parsedTag.length > 0 && 
                <View className={styles.tagBox}>
                  <View className={styles.ul}>
                    {this.parsedTag.map((e, ind) => (
                      <View className={styles.li}>
                        <View className={styles.item} onClick={() => {
                          this.handleDeleteTag(ind)
                        }}>
                          {e}
                          <Image src={this.assets.eswj.closeG} className={styles.ico} />
                        </View>
                      </View>
                    ))}
                  </View>
                </View>
              }
            </View>
          }
          <View className={this.cx(styles.sec, styles.nobord)}>
            <View className={styles.secInner}>
              <View className={this.cx(styles.title, styles.required)}>上传视频</View>
            </View>
            <View className={styles.uploadBox}>
              {params.video? (
                <View className={styles.videoBox}>
                  <video src={params.video} className={styles.video}></video>
                  <View className={styles.close} onClick={this.deleteVideo}>
                    <Image src={this.assets.eswj.closeG} className={styles.ico} />
                  </View>
                </View>
              ): (
                <View className={styles.imgBox}>
                  <Uploader onChange={this.handleVideoChange} max={1} type="video"/>
                </View>
              )}
            </View>
          </View>
          <View className={this.cx(styles.sec, styles.nobord)}>
            <View className={styles.secInner}>
              <View className={this.cx(styles.title, styles.required)}>视频介绍</View>
              <View className={styles.rig}>
                <View className={styles.rigBtn} onClick={() => {
                  // this.feedback.showFeedback('vlogPubVideoCaseModal')
                }}>
                  <Text>{"点此查看案例>>"}</Text>
                </View>
              </View>
            </View>
            <View className={styles.textreaBox}>
              <Textarea
                className={styles.textarea}
                value={params.desc || ''}
                name="desc"
                valueChange={this.handleParamChange.bind(this)}
                placeholder="请填写本视频的优势卖点，吸引更多人购买"
                maxLength={100}
              />
            </View>
          </View>

          {(this.parsedTag.length > 0 || userinfo.uploader !== 1) &&
            <View className={styles.sec}>
              <View className={styles.secInner} onClick={() => {
                // this.feedback.showFeedback('vlogPubBrandSelector')
              }}>
                <View className={this.cx(styles.title, styles.required)}>设备品牌</View>
                <View className={styles.rig}>
                  {params.brand && 
                    (<Text className={styles.blue}>#{params.brand}</Text>)
                  }
                  {params.brand? (
                    <Text className={styles.pdTxt}>{'修改 >'}</Text>
                  ): (
                    <Text className={styles.pdTxt}>{'点此选择 >'}</Text>
                  )}
                </View>
              </View>
            </View>
          }
          <View className={this.cx(styles.sec, styles.nobord)}>
            <View className={styles.secInner}>
              <View className={this.cx(styles.title, styles.required)}>价格区间(元)</View>
            </View>
            <View className={styles.priceBox}>
              <Text className={styles.des}>根据视频难易程度定，太高别人不看，建议不要超过20元</Text>
              <View className={styles.priceInner}>
                <View className={styles.inputBox}>
                  <Input
                    valueChange={this.handlePriceChange.bind(this, 0)}
                    type='number'
                    value={(params.scope_price || [])[0] || ''}
                    className={styles.input}
                    placeholder="最低价"
                  />
                </View>
                <View className={styles.dvd}></View>
                <View className={styles.inputBox}>
                  <Input
                    valueChange={this.handlePriceChange.bind(this, 1)}
                    type='number'
                    value={(params.scope_price || [])[1] || ''}
                    className={styles.input}
                    placeholder="最高价"
                  />
                </View>
              </View>
            </View>
          </View>
          </View>  
        </View>


        <Prompt
          isOpen={showBrandSelector}
          className={styles.modal}
        >
          <View className={styles.modalBox}>
            
          </View>
        </Prompt>










        <View className={styles.button} onClick={this.handleSubmit}>提交</View>
        
      </View>
    );
  }

  private getUserInfo = async () => {
    const { body } = await this.apiClient.base.kxbUserinfo();

    this.setState({
      userinfo:body
    })
  }

  private handleParamChange = (key, value) => {
    if (typeof value === 'object' && value.target) {
      value = value.target.value;
    }

    this.setState({
      params: {
        ...this.state.params,
        [key]: value,
      }
    });
  }
  private handlePriceChange = (num, value) => {
    const { params } = this.state
    if (typeof value === 'object' && value.target) {
      value = value.target.value;
    }

    let prArr = params.scope_price || []
    prArr[num] = Number(value)

    this.setState({
      params: {
        ...this.state.params,
        scope_price: prArr,
      }
    });
  }
  private handleTagBrandChange = (value) => {
    if (typeof value === 'object' && value.target) {
      value = value.target.value;
    }

    if(!this.currentEditingTag) {
      return;
    }
    const key = this.currentEditingTag.key

    this.setState({
        supply: {
          ...(this.state.supply || {}),
          [key]: value
        }
    });
  }

  private get parsedTag() {
    //格式化tag 格式：  #行车无力:冒烟,怠速
    const { tagSelected } = this.state
    if(!tagSelected || tagSelected.length == 0){
      return []
    }
    let res:string[] = []
    tagSelected.map(obj => {
      let value1 = '#'+obj.value
      let value2 = (obj.list || []).filter(e => !!e).join(',')  
      if(value2) {
        value1 = value1+':'+value2
      }
      res.push(value1)
    })
    return res
  }
  private handleTagSel = (e) => {
    const { tagSelected } = this.state
    let arr = tagSelected || []
    const name1:string = e.val1.name || ''
    const name2:string = e.val2? (e.val2.name || ''): ''
    
    let theChild = arr.find(e => e.value == name1)
    let childArr = theChild? theChild.list: []
    let ind = childArr.indexOf(name2)  //二级数据列表是否存在
    if(ind == -1){
      // if(name2) {  //空字符串先加进去，用来控制删除只有1级的数据（空要处理掉）
        childArr.push(name2)
      // }
    }else {
      childArr.splice(ind, 1)
      if(childArr.length == 0){
        //本来有的，被删到0了 就把整个都删掉
        let delInd = arr.findIndex(e => e.value == name1)
        arr.splice(delInd, 1)
      }
    }
    if(!theChild) {
      arr.push({
        value: name1,
        list: childArr
      })
    }
    this.setState({
      tagSelected: [...arr]
    })
    // this.feedback.hideFeedback('vlogPubFaultTypeModal')

    let brandTag = TAGS_WITH_BRAND.find(e => e.name == name1)
    if(brandTag) {
      // console.log('name1', name1, arr)
      this.setState({
        currentEditTag: name1
      })
      // this.feedback.showFeedback('vlogPubTagBrandModal')
    }
    // console.log('e:', e, arr)
  }
  private handleDeleteTag = (ind) => {
    //删除第ind个一级标签
    const { tagSelected } = this.state
    let arr = tagSelected || []
    arr.splice(ind, 1)
    // console.log("delete", ind, tagSelected, arr)
    this.setState({
      tagSelected: [...arr]
    })
  }
  private get currentEditingTag() {
    const { currentEditTag } = this.state
    const res = TAGS_WITH_BRAND.find(e => e.name == currentEditTag)
    return res;
  }
  private get currentEditingTagBrand() {
    const { supply } = this.state
    if(!this.currentEditingTag){return ''}
    const key = this.currentEditingTag.key
    // return params.supply? (params.supply[key] || ''): ''
    return supply? (supply[key] || ''): ''
  }

  private handleVideoChange = (videos) => {
    this.handleParamChange('video', videos[0] || '')
    // if(images && images[0]) {
    //   this.handleParamChange('images', images[0]) //封面图
    // }
  }
  private deleteVideo = () => {
    this.handleParamChange('video', '')
  }




  private handleSubmit = () => {
    const { params } = this.state
    console.log('params:::', params)
  }








  // private textareaChange = (name:'content', e) => {
  //   this.setState({
  //     [name]:  e.target.value
  //   })
  // }

  // private handleImagesChange = e => {
  //   const { imgs } = this.state
  //   this.setState({
  //     imgs: [...imgs, ...e]
  //   })
  // }

  // private deleteImg = (num) => {
  //   let { imgs } = this.state
  //   imgs.splice(num, 1)
  //   this.setState({
  //     imgs: [...imgs]
  //   })
  // }
  
  // private handleVideoChange = e => {
  //   this.setState({
  //     video: e[0]
  //   })
  // }
  

  // private deleteVideo = () => {
  //   this.setState({
  //     video: ''
  //   })
  // }

  // private handleSubmit = async() => {
  //   const { content, imgs, video} = this.state
  //   if(!content || content.length < 15){
  //     toast.error("至少填写15字设备介绍!", TOASTPARAMS)
  //     return;
  //   }
  //   if(!imgs || imgs.length < 1){
  //     toast.error("请上传照片!", TOASTPARAMS)
  //     return;
  //   }


  //   let search = this.props.location.search || ''
  //   let searchArr = search.split('?')
  //   let params:any = {}
  //   searchArr.length > 0 && searchArr.map(res => {
  //     if(!!res) {
  //       let arr = res.split('=')
  //       params[arr[0]] = arr[1]
  //     }
  //   })
  //   if(!params.sid) {
  //     toast.error("缺少sid!", TOASTPARAMS)
  //     return;
  //   }


  //   const res = await this.apiClient.base.pubCarFast({
  //     content, 
  //     sid: params.sid,
  //     imgs, 
  //     video
  //   })
  //   if(res.status == 10000) {
  //     toast.success('上传成功！', TOASTPARAMS)
  //     this.setState({
  //       content: '', 
  //       imgs: [], 
  //       video: ''
  //     })
  //   }else {
  //     toast.error(res.msg, TOASTPARAMS)
  //   }
  // }
}
